import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=154a21ad&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=154a21ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports